import React from 'react';
import MetricsGroupsPage from '@avtechsoftware/react-component-library/src/components/metrics/MetricsGroupsPage/MetricsGroupsPage';
import {
  masterDeviceListPropType,
} from '@avtechsoftware/react-component-library/src/types/AvtechPropTypes';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import { connect } from 'react-redux';
import MaxReportsBanner from '../../layout/MaxReportsBanner/MaxReportsBanner';
import envConfig from '../../../envConfig';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../utility/SecurityRules';
import {
  selectActiveSubscriptionCounts, selectSessionHash,
  selectSessionInformation, sessionInformationPropType,
} from '../../../redux/slices/sessionSlice';
import {
  selectAllThresholdRanges,
  selectThresholdRangeById,
} from '../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';
import { sessionHash } from '../../../utility/remoteServiceUtil';
import {
  channelKeyListToSensorList,
  selectByUuidOrMacAddress,
  selectRoomAlertDeviceList,
  selectSensorMap,
} from '../../../redux/slices/deviceList/deviceListSlice';
import { selectActiveAlertEventList } from '../../../redux/slices/alertEvents/alertEventsSlice';
import {
  dismissAllMessages, dismissMessage, pushSessionMessage, selectAllToastNotifications,
} from '../../../redux/slices/toastNotificationSlice/toastNotificationSlice';
import {
  getMetricsGroupContextRedux, selectAllMetricsGroups, selectMetricGroupById,
} from '../../../redux/slices/metricsGroupSlice/metricsGroupSlice';
import { store } from '../../../redux/store';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';

class MetricsGroupsPageConnected extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertList: [],
      isAlertListDataLoaded: false,
      // errorList: [],
    };
    this.getFullAlertList = this.getFullAlertList.bind(this);
    this.getAlertById = this.getAlertById.bind(this);
    this.redirectToMetricGroupPage = this.redirectToMetricGroupPage.bind(this);
    this.redirectToExploreMetrics = this.redirectToExploreMetrics.bind(this);
  }

  async componentDidMount() {
    await RaaAuthenticatedRemoteService.globalInstance()
      .get(`${envConfig.apiUrl}/api/v1/alerts`)
      .then((response) => {
        this.setState({
          isAlertListDataLoaded: true,
          alertList: [...response.alertList],
        });
      })
      .catch(() => {
        // error handling
      });
  }

  getFullAlertList() {
    const { alertList } = this.state;
    return alertList;
  }

  getAlertById(id) {
    const { alertList } = this.state;
    return alertList.find((alert) => alert.id === id);
  }

  redirectToMetricGroupPage(metricGroupId) {
    const { history } = this.props;
    history.push(`/s/sensor-data/groups/${metricGroupId}`);
  }

  redirectToExploreMetrics() {
    const { history } = this.props;
    history.push('/s/sensor-data/explore');
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToUpgradeAccount() {
    window.location.assign(`${envConfig.raaUrl}/s/subscription/billing/change-plan`);
  }

  // eslint-disable-next-line class-methods-use-this
  renderLoadingSpinner() {
    return (
      <div className="row d-flex justify-content-center mt-5">
        <div>
          <ProgressSpinner progressText="" />
        </div>
      </div>
    );
  }

  render() {
    const {
      toastNotificationContext,
      metricsGroupContext,
      masterDeviceListContext,
      activeSubscriptionCounts,
      sessionInformation,
      thresholdRangeContext,
      dispatch,
      activeAlertEventList,
    } = this.props;
    const { isAlertListDataLoaded } = this.state;
    const { reportCount, reportLimit } = activeSubscriptionCounts;
    const { activeSubscription } = sessionInformation;
    const additionalHeaderContent = (
      <MaxReportsBanner
        reportCount={reportCount}
        reportLimit={reportLimit}
        hasAdminPrivileges={
          sessionUserHasRolePrivileges(activeSubscription, [RaaRoles.ADMIN])
        }
      />
    );
    if (!isAlertListDataLoaded) {
      return this.renderLoadingSpinner();
    }

    /* istanbul ignore next */
    const metricsGroupContextRedux = {
      ...metricsGroupContext,
      ...getMetricsGroupContextRedux(dispatch),
      findById: (mId) => selectMetricGroupById(store.getState(), mId),
      findAll: () => selectAllMetricsGroups(store.getState()),
    };

    /* istanbul ignore next */
    return (
      <MetricsGroupsPage
        getFullAlertList={this.getFullAlertList}
        getActiveAlertEventList={() => activeAlertEventList}
        metricsGroupContext={metricsGroupContextRedux}
        pushSessionMessage={(level, title, body) => dispatch(
          toastNotificationContext.pushSessionMessage(
            { level, title, body },
          ),
        )}
        masterDeviceList={masterDeviceListContext}
        temperatureScale={sessionInformation.temperatureScale}
        jwt={`${sessionHash}`}
        reportDataUrlBase={`${envConfig.apiUrl}/api/v1/device-data/device/samples/find-by-channel-keys`}
        timeZoneName={sessionInformation.timezone}
        hasEditPrivileges={
          sessionUserHasRolePrivileges(activeSubscription, [RaaRoles.ADMIN, RaaRoles.MANAGER])
        }
        redirectToMetricGroupPage={this.redirectToMetricGroupPage}
        redirectToExploreMetrics={this.redirectToExploreMetrics}
        additionalHeaderContent={additionalHeaderContent}
        onUpgradeAccountClick={this.redirectToUpgradeAccount}
        thresholdRangeContext={thresholdRangeContext}
        toggleGroupFavorite={metricsGroupContextRedux.toggleMetricGroupFavorite}
        userHasAdminPrivileges={sessionUserHasRolePrivileges(activeSubscription, [RaaRoles.ADMIN])}
      />
    );
  }
}

MetricsGroupsPageConnected.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  toastNotificationContext: PropTypes.shape({
    dismissMessage: PropTypes.func.isRequired,
    dismissAllMessages: PropTypes.func.isRequired,
    pushSessionMessage: PropTypes.func.isRequired,
  }).isRequired,
  metricsGroupContext: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    findById: PropTypes.func.isRequired,
  }).isRequired,
  masterDeviceListContext: masterDeviceListPropType.isRequired,
  thresholdRangeContext: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    findById: PropTypes.func.isRequired,
  }).isRequired,
  sessionInformation: sessionInformationPropType.isRequired,
  activeSubscriptionCounts: PropTypes.objectOf(PropTypes.any).isRequired,
  dispatch: PropTypes.func.isRequired,
  activeAlertEventList: PropTypes.arrayOf(
    PropTypes.shape({ alertId: PropTypes.string.isRequired }),
  ).isRequired,
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  sessionInformation: selectSessionInformation(state),
  activeSubscriptionCounts: selectActiveSubscriptionCounts(state),
  sessionHash: selectSessionHash(state),
  thresholdRangeContext: {
    findById: (id) => selectThresholdRangeById(state, id),
    findAll: () => selectAllThresholdRanges(state),
  },
  toastNotificationContext: {
    getAllMessages: () => selectAllToastNotifications(state),
    dismissMessage: (id) => dismissMessage(id),
    pushSessionMessage: (message) => pushSessionMessage(message),
    dismissAllMessages: () => dismissAllMessages(),
  },
  activeAlertEventList: selectActiveAlertEventList(state),
  masterDeviceListContext: {
    findByUUID: (id) => selectByUuidOrMacAddress(state, id),
    getSensorMap: () => selectSensorMap(state),
    getFullDeviceList: () => selectRoomAlertDeviceList(state),
    channelKeyListToSensorList: (channelKeyList) => channelKeyListToSensorList(
      state, channelKeyList,
    ),
  },
  metricsGroupContext: {
    findById: () => {},
    findAll: () => {},
  },
});
export { MetricsGroupsPageConnected };

export default withRouter(
  connect(mapStateToProps)(MetricsGroupsPageConnected),
);
